/**
 * Taskbar clock: `9:41 PM`, matching XP's default short time.
 *
 * The iPod's title bar reads the same formatter rather than carrying a second
 * one, because the two shells have to agree about the minute they are
 * showing.
 */
export function formatClock(d: Date): string {
  const m = d.getMinutes().toString().padStart(2, '0');
  let h = d.getHours();
  const suffix = h >= 12 ? 'PM' : 'AM';
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${m} ${suffix}`;
}

const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/** Clock tooltip: `Saturday, August 16, 2026`. */
export function formatLongDate(d: Date): string {
  return `${DAYS[d.getDay()]}, ${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
}

/** Explorer's Details pane: `16/08/2026 21:09`. */
export function formatFileDate(d: Date): string {
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/**
 * A property sheet's Created / Modified / Accessed lines:
 * `16 August 2026, 21:09:34`.
 *
 * The long form of `formatFileDate` rather than of `formatLongDate`: it is
 * describing the same three files the Details view is, so it puts the day
 * first the way that column does, and it carries seconds because the sheet was
 * the one place in the shell that showed them.
 */
export function formatStampDate(d: Date): string {
  const pad = (n: number) => n.toString().padStart(2, '0');
  const time = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}, ${time}`;
}
